import { StubPage } from '../components/StubPage';

export function TemplatesPage() {
  return (
    <StubPage
      title="Templates"
      description="CMS bilingue des templates servis dans le workspace founder (cap-table, FDD letter, runway model, board pack)."
      icp="Gaetan en mode admin, pour maintenir des templates versionnés et bilingues sans devoir éditer un fichier markdown dans le repo."
      status="PR 1 stub"
      tableTarget="Templates (à créer, env AIRTABLE_TABLE_TEMPLATES)"
      reads={['Title FR / EN', 'Type', 'Version', 'Last update', 'Published']}
      edits={['Body FR / EN markdown, Preview link, Files attached en side-panel']}
    />
  );
}
